import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const StrengthValueUnitSelect = ({ allowClear = true,
  setValueAsObject = false,
  value,
  disabled,
  ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      setValueAsObject={ setValueAsObject }
      disabled={ disabled }
      allowClear={ allowClear }
      value={ setValueAsObject ? value?.value : value }
      options={ [
        { text: '%', value: '1' },
        { text: 'µg', value: '2' },
        { text: 'µg/ml', value: '3' },
        { text: 'DOSE', value: '22' },
        { text: 'g', value: '4' },
        { text: 'g/l', value: '5' },
        { text: 'g/ml ', value: '6' },
        { text: 'iu', value: '9' },
        { text: 'IU', value: '7' },
        { text: 'IU/ml', value: '8' },
        { text: 'kBq/ml', value: '10' },
        { text: 'mEq', value: '11' },
        { text: 'mEq/g', value: '12' },
        { text: 'mEq/ml', value: '13' },
        { text: 'mg', value: '14' },
        { text: 'mg/g', value: '15' },
        { text: 'mg/ml', value: '16' },
        { text: 'ml', value: '17' },
        { text: 'mMol', value: '18' },
        { text: 'mMol/ml', value: '19' },
        { text: 'PFU', value: '21' },
        { text: 'U', value: '20' }
      ] }
    />
  );
};
export default StrengthValueUnitSelect;
